import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { ClientModel, AbstractCategory } from "@devowl-wp/utils";
import { request } from "../utils";
import { CookieCollection } from ".";
import { action, observable, runInAction, flow, computed } from "mobx";
class CookieGroupModel extends AbstractCategory {
    get cookiesCount() {
        // TODO: this.data.count should return a count also of private cookies
        return this.fetchedAllCookies ? this.cookies.entries.size : this.data.count;
    }
    constructor(collection, data = {}){
        super(collection, data);
        this.fetchedAllCookies = false;
        this.fetchCookies = flow(function*() {
            yield this.cookies.get({
                request: {
                    status: [
                        "draft",
                        "publish",
                        "private"
                    ]
                },
                params: {
                    per_page: 100,
                    "rcb-cookie-group": this.key,
                    context: "edit"
                }
            });
            this.fetchedAllCookies = true;
        });
        runInAction(()=>{
            this.cookies = new CookieCollection(this);
        });
    }
    setName(name) {
        this.data.name = name;
    }
    setDescription(description) {
        this.data.description = description;
    }
    setOrder(order) {
        this.data.meta.order = order;
    }
    afterDelete() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterPatch() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterPersist() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof CookieCollection === "undefined" ? Object : CookieCollection)
], CookieGroupModel.prototype, "cookies", void 0);
_ts_decorate([
    observable
], CookieGroupModel.prototype, "fetchedAllCookies", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], CookieGroupModel.prototype, "cookiesCount", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieGroupModel.prototype, "setName", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieGroupModel.prototype, "setDescription", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Number
    ]),
    _ts_metadata("design:returntype", void 0)
], CookieGroupModel.prototype, "setOrder", null);
CookieGroupModel = _ts_decorate([
    ClientModel.annotate({
        keyId: "id",
        namespace: "wp/v2",
        request,
        create: {
            path: "/rcb-cookie-group"
        },
        patch: {
            path: "/rcb-cookie-group/:id"
        },
        delete: {
            path: "/rcb-cookie-group/:id"
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof CookieGroupCollection === "undefined" ? Object : CookieGroupCollection,
        typeof Partial === "undefined" ? Object : Partial
    ])
], CookieGroupModel);
export { CookieGroupModel };
